import { useState } from 'react'
import type { InteractionProps } from './registry'
import { getNonEmptyString } from './shared/config'
import { asRecord } from './shared/response'
import { StaticFallback } from './shared/StaticFallback'
import controls from './shared/controls.module.css'
import styles from './Reveal.module.css'

/**
 * Progressive disclosure: hide an answer or explanation behind a toggle so the
 * learner attempts or predicts first. Completion fires on first reveal.
 */
export function Reveal({ id, config, savedResponse, onResponseChange, onComplete }: InteractionProps) {
  const prompt = getNonEmptyString(config, 'prompt') ?? 'Reveal'
  const answer = getNonEmptyString(config, 'answer')

  const saved = asRecord(savedResponse)
  const [revealed, setRevealed] = useState<boolean>(saved.revealed === true)

  if (!answer) {
    return <StaticFallback title={prompt}>Nothing to reveal.</StaticFallback>
  }

  const regionId = `${id}-region`

  function toggle() {
    const next = !revealed
    setRevealed(next)
    onResponseChange?.({ revealed: next })
    if (next) onComplete?.()
  }

  return (
    <section className={controls.interaction}>
      <button
        type="button"
        className={`${controls.button} ${controls.buttonPrimary}`}
        aria-expanded={revealed}
        aria-controls={regionId}
        onClick={toggle}
      >
        {revealed ? 'Hide' : prompt}
      </button>
      <div id={regionId} className={styles.region} hidden={!revealed}>
        {answer}
      </div>
    </section>
  )
}
